import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import App from "./App";
import store from "./app/store";
import reportWebVitals from "./reportWebVitals";
import { MsalProvider } from "@azure/msal-react";
import { PublicClientApplication } from "@azure/msal-browser";

function generateMsalConfig() {
  const msalConfig = {
    auth: {
      clientId: "20febb85-5334-4856-b7ad-6904eedc7103",
      authority:
        "https://login.microsoftonline.com/bc0c325b-6efc-4ca8-9e46-11b50fe2aab5/",
      redirectUri: "https://leca.lendlease.com/",
    },
    cache: {
      cacheLocation: "sessionStorage", // This configures where your cache will be stored
      storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
    },
  };

  return msalConfig;
}

const msalInstanceProvider = new PublicClientApplication(generateMsalConfig());

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Provider store={store}>
    <React.StrictMode>
      <MsalProvider instance={msalInstanceProvider}>
        <App />
      </MsalProvider>
    </React.StrictMode>
  </Provider>
);

reportWebVitals();
